import React from 'react'

function Icon(props) {
  const { fill = '#F05826' } = props
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="15"
      fill="none"
      viewBox="0 0 21 15"
      {...props}
    >
      <path
        fill={fill}
        fillRule="evenodd"
        d="M14.477 14.322a.442.442 0 01-.67 0 .565.565 0 010-.742l5.057-5.6H.988a.5.5 0 110-1h17.88l-5.062-5.607a.565.565 0 010-.742.442.442 0 01.67 0l5.847 6.475.005.006a.499.499 0 01-.018.751l-5.833 6.459z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export default Icon
